import { getUtcUsFormatDate } from 'modules/utils/time';
import { TableCell } from 'types/common/table';

export default [
  {
    align: 'center',
    name: 'Changed Date',
    key: 'changedDate',
    render: rowData => getUtcUsFormatDate(rowData.changedDate),
  },
  {
    align: 'center',
    name: 'Previous Email',
    key: 'previousEmail',
    render: rowData => rowData.previousEmail,
  },
  {
    align: 'center',
    name: 'Changed Email',
    key: 'changedEmail',
    render: rowData => rowData.changedEmail,
  },
] as TableCell[];
